module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t12"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("OLORS")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("HAS")]), _vm._v(" been in development for several years. So many people helped me hone the plot, flesh out the characters. I thank them all, especially Varsha Bajaj, Kathy Duval, Linda Jackson, Marty Graham, and Vonna Carter. As budding writers, we struggled together and made the process so much easier. Most of all, I thank my friend and mentor Kelly Bennett. When I first met Kelly, I had a desire to write (nurtured by the supremely wonderful writer, teacher, and mentor Kathi Appelt), and Kelly has stood by me, coaxed me, taught me, critiqued my work, and shown me I do know what I’m doing. Finally, Dreamspinner Press and Harmony Ink must be thanked for giving me a wonderful publishing home. I’m grateful every day for their support and faith in me as a writer.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0